import script from "./EmployeeMainSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeMainSideBar.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeMainSideBar.vue?vue&type=style&index=0&id=9f0957e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0957e6"]])

export default __exports__